import { Api } from "@penn/web-common";
import { unwrap } from "@penn/web-common";

// =============================================================================
// Per-task manual line items (svc-06, /v1/tasks/:taskId/manual-line-items).
// Mirrors packages/shared-types/src/svc-06-quotation/v1/manual-line-item.schema.ts.
// Money is a Decimal-precision string on the wire (rule §D.12).
// =============================================================================

export interface ManualLineItemInput {
  description: string;
  /** Decimal string, up to 4 dp. */
  price: string;
  qty: number;
  currency: string;
  isManual?: boolean;
  partNo?: string | null;
  category?: string | null;
  toolingType?: string | null;
  machineType?: string | null;
  itemName?: string | null;
  partName?: string | null;
}

export interface ManualLineItem {
  itemId: string;
  taskId: string;
  isManual: boolean | null;
  partNo: string | null;
  description: string | null;
  category: string | null;
  toolingType: string | null;
  machineType: string | null;
  itemName: string | null;
  partName: string | null;
  currency: string | null;
  price: string | null;
  qty: number | null;
  autoApproved: boolean;
  createdByEmail: string | null;
  createdByName: string | null;
  createdByRole: string | null;
  createdBy: string | null;
  createdAt: string;
  updatedAt: string;
}

export async function listManualLineItems(taskId: string): Promise<ManualLineItem[]> {
  const res = await Api.get(
    `/v1/tasks/${encodeURIComponent(taskId)}/manual-line-items`,
  );
  return unwrap<{ items: ManualLineItem[] }>(res.data).items;
}

export async function addManualLineItem(
  taskId: string,
  body: ManualLineItemInput,
): Promise<ManualLineItem> {
  const res = await Api.post(
    `/v1/tasks/${encodeURIComponent(taskId)}/manual-line-items`,
    body,
  );
  return unwrap<ManualLineItem>(res.data);
}

export async function deleteManualLineItem(
  taskId: string,
  itemId: string,
): Promise<void> {
  await Api.delete(
    `/v1/tasks/${encodeURIComponent(taskId)}/manual-line-items/${encodeURIComponent(itemId)}`,
  );
}
